import type { ComponentMetaInput } from '../../ui';
import { EDITOR_BACK_BOX, EDITOR_HEADER_BOX, EDITOR_SAVE_BOX, EDITOR_TITLE_BOX, PAGE_BOX } from './layout';

function part(key: string, label: string, x: number, y: number, width: number, height: number, role: ComponentMetaInput['role'] = 'input'): ComponentMetaInput {
  const androidView = role === 'container' ? 'ViewGroup' : role === 'text' ? 'TextView'
    : key === 'stream' ? 'SwitchMaterial' : role === 'button' ? 'MaterialButton'
      : ['provider', 'model', 'thinking'].includes(key) ? 'Spinner' : 'TextInputEditText';
  return { id: `presets.model.${key}`, page: 'presets', role, label, layout: { x, y, width, height }, zIndex: 6,
    notes: `${label}；安卓用 ${androidView}` };
}

export const ROLE_MODEL_META = {
  root: part('root', '角色模型配置页面', PAGE_BOX.x, PAGE_BOX.y, PAGE_BOX.width, PAGE_BOX.height, 'container'),
  header: { ...part('header', '模型配置标题栏', 0, 0, 390, 56, 'container'), layout: EDITOR_HEADER_BOX },
  title: { ...part('title', '模型配置', 60, 16, 180, 24, 'text'), layout: EDITOR_TITLE_BOX },
  cancel: { ...part('cancel', '取消模型配置', 8, 8, 44, 40, 'button'), layout: EDITOR_BACK_BOX },
  apply: { ...part('apply', '应用模型配置', 290, 8, 92, 40, 'button'), layout: EDITOR_SAVE_BOX },
  error: part('error', '模型配置错误', 8, 60, 374, 72, 'text'),
  form: part('form', '模型配置表单', 0, 72, 390, 672, 'container'),
  providerLabel: part('providerLabel', '模型提供商', 16, 88, 358, 18, 'text'),
  provider: part('provider', '模型提供商', 16, 112, 358, 40),
  modelLabel: part('modelLabel', '模型', 16, 168, 358, 18, 'text'),
  model: part('model', '模型', 16, 192, 358, 40),
  limits: part('limits', '模型能力与状态', 16, 242, 358, 42, 'text'),
  maxContextLabel: part('maxContextLabel', '最大上下文', 16, 296, 358, 18, 'text'),
  maxContext: part('maxContext', '最大上下文', 16, 320, 358, 40),
  maxOutputTokensLabel: part('maxOutputTokensLabel', '最大输出 token', 16, 376, 358, 18, 'text'),
  maxOutputTokens: part('maxOutputTokens', '最大输出 token', 16, 400, 358, 40),
  temperatureLabel: part('temperatureLabel', '温度', 16, 456, 170, 18, 'text'),
  temperature: part('temperature', '温度', 16, 480, 170, 40),
  topPLabel: part('topPLabel', 'TopP', 204, 456, 170, 18, 'text'),
  topP: part('topP', 'TopP', 204, 480, 170, 40),
  thinkingLabel: part('thinkingLabel', '思考等级', 16, 536, 358, 18, 'text'),
  thinking: part('thinking', '思考等级', 16, 560, 358, 40),
  streamLabel: part('streamLabel', '流式输出', 16, 624, 260, 24, 'text'),
  stream: part('stream', '流式输出', 312, 620, 62, 32, 'button'),
};
